var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Dialog",
    {
      staticClass: "component-online-dialog",
      attrs: { title: "【重要】峰会全体学生通知" },
      on: { close: _vm.handleClose }
    },
    [
      _c("Scrollbar", { staticClass: "online-dialog-content _el-scrollbar" }, [
        _c("div", { staticClass: "online-dialog-content-wrap" }, [
          _c("p", { staticClass: "text" }, [_vm._v("亲爱的HSYLCer和家长")]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 在上一封邮件发出后的三天里，多地聚集性疫情形势还在不断升级，根据7月31日下午国务院联防联控机制新闻发布会上介绍的本轮疫情最新情况，疫情还有继续扩散的风险，已有超过29个省市建议市民非必要不出省/不离市，并严格控制校园聚集型活动、暂停一切线下形式教学活动。我们也已经得到了峰会三地主办学校和上级主管单位的通知，在此很遗憾地告知你， "
            ),
            _c("span", { staticClass: "bold" }, [
              _vm._v(
                " 今年的峰会将转移到线上进行，回归2020年疫情重创时期的云端夏校形式，日期和主要活动日程保持不变，打通三地选课等学习资源，提供更多Seminar增修机会。除此以外，在疫情缓解后秋季周末时间，我们将在哈佛中心（上海）等场地举办线下学术文化交流活动，本届峰会各方面表现优异的同学将受邀参加。 "
              )
            ])
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 在过去两周内，我们不断通过第一时间劝退中高风险地区学生、为每个会场准备提前现场核酸场地和住宿方案、要求所有成年工作人员完成疫苗注射等措施，使线下峰会符合特殊时期疫情防控要求的每一次调整。但持续发展的疫情超出了所有人的预期，我们不得不启动最后一套全线上预案。 "
            )
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 主办学校和峰会组委会必须将所有参与人员的安全健康放在首位，但我们也非常理解你此刻心中可能的失望。几百位国内学者、哈佛等海外学者、工作人员此刻和你一样难过无法在盛夏的校园见到彼此。我们在准备线上预案的每一天，都希望这是一套最终会被浪费的预案。虽然万般理解疫情两年来你期待线下活动的心愿，但在疫情扩散和临近开学之际，绝不希望因为线下聚集带来开学隔离、耽误入学的困难。在众多线下活动和出行计划先后取消的当下，能够处变不惊地把学习计划持续推进，往往正是同龄人间拉开差距的时刻。 "
            )
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 现在，我们想邀请你一起来了解一下，线上峰会对你意味着什么，这样当你做接下来的决定时，不会被一时的失望冲击，而失去对这次机会理智客观的判断。别担心，你有足够的时间来完成这个重要的决定，也欢迎和我们沟通后再做出决定： "
            )
          ]),
          _c("p", { staticClass: "mt-30 big text red bold" }, [
            _vm._v("三地打通Seminar增选即将开启")
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 线上峰会将恢复2020年云端夏校的三地打通选课机制，在你目前分到并正在预习的Seminar之外，200+门哈耶普斯、北清复交学者带来的热门Seminar都将重新开放， "
            ),
            _c("span", { staticClass: "bold" }, [
              _vm._v(
                " 你原有的主修方向和当前选课不变的前提下，可以额外选修英文和双语seminar各一门。 "
              )
            ])
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 此前同样因为会场地点限制而十分抢手的Frontier Conversation以及Cornerstone Workshop机会，也将打通三个会场的选项，每位同学最多可以增选2个Frontier Conversation机会。 "
            )
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 从现在开始，你已经可以点击邮件最下方按钮去浏览三个会场所有的Seminar和Frontier Conversation介绍，开始做自己的计划，增选抢课通道即将在 "
            ),
            _c("span", { staticClass: "bold red" }, [
              _vm._v("北京时间8月4日晚8点")
            ]),
            _vm._v(" 开通。 ")
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 多个学术、升学、职场等方向的Cornerstone Workshop预约报名将在 "
            ),
            _c("span", { staticClass: "red bold" }, [
              _vm._v("北京时间8月9日上午9点")
            ]),
            _vm._v(
              " 开放，按照峰会学术要求，每位同学至少参加2门，不设上限。峰会为每一位完成所有学术挑战的同学出具官方证书和成绩单，并有荣誉学生和最高荣誉学生供你挑战，线上版峰会保持不变。 "
            )
          ]),
          _c("p", { staticClass: "text big red bold mt-30" }, [
            _vm._v(" 众多世界名校现任招生官、大学官方领导为你而来 ")
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 由于线上的无国界优势，今年齐聚峰会将与你见面的世界名校嘉宾阵容史无前例地强大，包括数十所世界名校国际招生或中国地区招生负责人： "
            )
          ]),
          _c("div", { staticClass: "mt-20 flex-wrap text bold" }, [
            _c("div", { staticClass: "item" }, [
              _vm._v(" 哈佛大学现任招生官"),
              _c("br"),
              _vm._v(" 牛津大学现任招生官"),
              _c("br"),
              _vm._v(" 剑桥大学现任招生官"),
              _c("br"),
              _vm._v(" 杜克大学现任招生官"),
              _c("br"),
              _vm._v(" 约翰霍普金斯大学现任招生官"),
              _c("br"),
              _vm._v(" 帝国理工大学现任招生官"),
              _c("br"),
              _vm._v(" Yale-NUS现任招生官 ")
            ]),
            _c("div", { staticClass: "item" }, [
              _vm._v(" 上海纽约大学现任招生官"),
              _c("br"),
              _vm._v(" 麦吉尔大学现任招生官"),
              _c("br"),
              _vm._v(" 韦尔斯利学院现任招生官"),
              _c("br"),
              _vm._v(" 波士顿大学现任招生官"),
              _c("br"),
              _vm._v(" 佐治亚理工大学现任招生官"),
              _c("br"),
              _vm._v(" …… ")
            ])
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              "此外还有以下世界名校官方领导与你分享大学的学术高度与国际视野："
            )
          ]),
          _c("p", { staticClass: "text mt-20 bold" }, [
            _vm._v(" 哈佛中心（上海）执行董事"),
            _c("br"),
            _vm._v(" 耶鲁北京中心董事总经理"),
            _c("br"),
            _vm._v(" 北京大学斯坦福中心执行董事"),
            _c("br"),
            _vm._v(" 上海纽约大学总教务长、历史学教授"),
            _c("br"),
            _vm._v(" 哈佛商学院出版中国执行总监"),
            _c("br"),
            _vm._v(
              " 哈佛大学肯尼迪学院亚洲中心前执行主任，斯坦福大学亚太研究中心前副主任，清华大学苏世民学者前副主任"
            ),
            _c("br"),
            _vm._v(" 哈佛大学教育学院教授，哈佛全校写作项目设计者"),
            _c("br"),
            _vm._v(" 耶鲁大学法国语言文学系语言项目主任"),
            _c("br"),
            _vm._v(" …… ")
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 其中，招生官们除了带来HSYLC专场College Fair info sessions之外，还将三两配合，共同亲身分享关于大学申请文书写作技巧、如何选择专业、如何选择大学、未来职业发展、招生政策等一手信息解读。还将开放少量席位，让同学可以和招生官小范围线上交流QA，解答你的个性化问题。"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              " 更多跨界大师课嘉宾阵容，包括多位知名教授、《奇葩说》嘉宾、体育世界冠军、脱口秀明星、DJ专业人士、亿元爆款品牌和独角兽企业创始人……我们会在即将到来的峰会向你一一揭晓。 "
            )
          ]),
          _c("p", { staticClass: "text bold red big mt-30" }, [
            _vm._v("全国杰出同龄人的温暖集体等你加入")
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 此刻，你可能还无法想象今年夏天即将加入的线上峰会究竟会有多么“上头”。即将成立的“学院保卫战”指挥司令部，开闸即刷屏的峰会版聊论坛，在听完两位真《奇葩说》嘉宾分享后，战火重燃的“峰会奇葩说”……有校友说，只有亲身经历，才能明白峰会是一个可以将人与人间几个月的交流缩短到几天的神奇地方，虽然我们素未谋面，却仿佛早已灵魂相交。 "
            )
          ]),
          _c("ul", { staticClass: "ul text mt-20" }, [
            _c("li", [
              _vm._v(
                "“我从来没有想过一个线上活动，能有这‘十天抵过了十年’的效果”"
              )
            ]),
            _c("li", [
              _vm._v(
                "“学院保卫战这个游戏有毒，会激发出强烈的集体荣誉感和对house的责任感！”"
              )
            ]),
            _c("li", [
              _vm._v(
                "“为house写歌词，与会作曲的异地小伙伴云端合作的感觉太妙了！”"
              )
            ]),
            _c("li", [
              _vm._v(
                " “线上的HSYLC有着无限的可能性，如果是线下，我可能也没有机会上到这么多优秀的老师的课，无法认识到来自天南地北的小伙伴们，也更无法拥有和他们一起享受这十天的经历” "
              )
            ])
          ]),
          _c("p", { staticClass: "text mt-30 red bold big" }, [
            _vm._v("期待秋天线下相聚")
          ]),
          _c("p", { staticClass: "text mt-20" }, [
            _vm._v(
              " 虽然在8月11日-20日的峰会期间我们只能以线上方式相见，但我们非常期待并已经在准备，9月开学后利用周末时间，在哈佛中心（上海）等场地，借助先进的跨国同步课堂设备，和现场及哈佛校园的师生进行前沿学术讲座和互动交流。届时，今年因疫情变动失去线下相聚机会的本届峰会学生中各方面表现优异的同学，将受邀参加分不同学术领域和兴趣方向的线下学术和文化交流活动。具体日期将在本轮疫情得到全面控制、各地中小学恢复学生线下聚集和跨省出行之后，第一时间向线上峰会期间各项荣誉和突出成绩获得者发出邀请，我们鼓励你积极参与峰会各项活动，来到后续线下活动，弥补遗憾。 "
            )
          ]),
          _c("div", { staticClass: "hr mt-30" }),
          _c("p", { staticClass: "text mt-30" }, [
            _vm._v(
              " 我们会在2周内为你退回线下住宿和饮食费用差价2000元，将原路退回你当时的支付账户，改为线上的峰会的全部费用回到和2020年全线上版峰会一致。在顺利完成峰会的10天挑战后，每一位同学将被授予峰会官方证书和接轨大学制式的GPA成绩单，展现你从超200门世界名校学者Seminar中的选课组合、所修学分和学术成绩，收获今夏一份有力的学术认可。学业表现突出的学生将获得荣誉证书和最高荣誉证书，并获得峰会组委会官方推荐信。成绩单和推荐信将在你未来申请大学时从组委会寄往世界各地的大学招生办，展现你的学术成就。"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              " 原本我们准备在峰会现场签到时交给你的伴随现场学习的峰会周边，也将会在线上峰会前后时间，变成一份线上峰会时期的实体纪念礼包，通过快递送达。此前已得到助学金大部分费用减免的同学，你的助学金金额和所支付金额（如有）都将保持不变，你此前已经申请的电脑设备支持也会照旧寄达，无需担心。"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              " 如果你因为这些疫情带来的最新变化，很遗憾无法出席峰会，请在 "
            ),
            _c("span", { staticClass: "bold red" }, [_vm._v("8月3日23:59前")]),
            _vm._v(" 提交退费申请表 "),
            _c(
              "a",
              {
                staticClass: "href bold red",
                attrs: {
                  href: "https://hedu.jinshuju.com/f/3BKyCc ",
                  target: "_blank"
                }
              },
              [_vm._v("https://hedu.jinshuju.com/f/3BKyCc ")]
            ),
            _vm._v(
              " 和详细的退出背景说明，收到后我们会与你进一步联系，确认退出后你的席位将立即给予等候名单上的同学。 "
            )
          ]),
          _c("p", { staticClass: "text mt-30" }, [
            _vm._v(
              " 如果你对这一变化有任何问题，可以随时与我们沟通，根据你的高中所在地区，可联系以下组委会老师："
            ),
            _c("br"),
            _c("br"),
            _vm._v(" 华北地区：13522342604（林老师）"),
            _c("br"),
            _vm._v(" 浙江、江苏地区：17521138086（王老师）"),
            _c("br"),
            _vm._v(" 上海地区：13564026438（徐老师）"),
            _c("br"),
            _vm._v(" 华南地区及山东：13428776513（顾老师）"),
            _c("br"),
            _vm._v(" 中西部地区：13808048205（王老师）"),
            _c("br"),
            _c("br"),
            _vm._v(
              " 若你不在以上地区，你还可以拨打400-180-5580或添加峰会小助手微信 (微信ID：hsylcassistant) 询问。"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              " 峰会的活动形式从来不会改变我们的初心，我们为了给每一位优秀的参与者提供一个在国内高中阶段无可比拟的国际平台一直在努力。你的初心是什么？这些线上带来的变化，能不能帮助你更好地完成你的初心？请告诉我们你的想法，我们会认真倾听。期待与你线上相见！"
            ),
            _c("br"),
            _c("br"),
            _vm._v(" HSYLC工作组 ")
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "online-read-submit" },
        [
          _c("p", { staticClass: "text bold" }, [
            _vm._v("我已阅读上述重要通知，前往查看三地所有Seminar")
          ]),
          _c(
            "Button",
            {
              staticClass: "online-read-submit-btn",
              on: { click: _vm.handleClickSubmit }
            },
            [_vm._v("确认")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }